import BusinessCentral from '../public/images/BusinessCentral.svg';
import CategoryAIMachineLearning from '../public/images/CategoryAIMachineLearning.svg';
import CategoryAIMachineLearningGrey from '../public/images/CategoryAIMachineLearningGrey.svg';
import AIAgents from '../public/images/AIAgents.svg';
import AIAgentsGrey from '../public/images/AIAgentsGrey.svg';
import Commerce from '../public/images/Commerce.svg';
import CustomerService from '../public/images/CustomerService.svg';
import CustomerVoice from '../public/images/CustomerVoice.svg';
import MixedReality from '../public/images/MixedReality.svg';
import Excel from '../public/images/Excel.svg';
import FieldService from '../public/images/FieldService.svg';
import FinanceOperations from '../public/images/FinanceOperations.svg';
import Guides from '../public/images/Guides.svg';
import HumanResorces from '../public/images/HumanResorces.svg';
import Marketing from '../public/images/Marketing.svg';
import Office from '../public/images/Office.svg';
import OneNote from '../public/images/OneNote.svg';
import Outlook from '../public/images/Outlook.svg';
import PowerApps from '../public/images/PowerApps.svg';
import PowerAutomate from '../public/images/PowerAutomate.svg';
import PowerBI from '../public/images/PowerBI.svg';
import PowerPoint from '../public/images/PowerPoint.svg';
import PowerVirtualAgents from '../public/images/PowerVirtualAgents.svg';
import Project from '../public/images/Project.svg';
import ProjectOperations from '../public/images/ProjectOperations.svg';
import ProjectServiceAutomation from '../public/images/ProjectServiceAutomation.svg';
import RemoteAssist from '../public/images/RemoteAssist.svg';
import Sales from '../public/images/Sales.svg';
import ServicesDynamics365 from '../public/images/ServicesDynamics365.svg';
import ServicesMicrosoft365 from '../public/images/ServicesMicrosoft365.svg';
import ServicesPowerPlatform from '../public/images/ServicesPowerPlatform.svg';
import SharePoint from '../public/images/SharePoint.svg';
import SupplyChainManagement from '../public/images/SupplyChainManagement.svg';
import Teams from '../public/images/Teams.svg';
import Word from '../public/images/Word.svg';
import MSlogo from '../public/images/MSlogo.svg';
import MSlogoSmall from '../public/images/MSlogoSmall.svg';
import Separator from '../public/images/Separator.svg';
import Partners from '../public/images/Partners.svg';
import Azure from '../public/images/Azure.svg';
import ChevronRight from '../public/images/ChevronRight.svg';
import PowerPages from '../public/images/PowerPages.svg';
import Viva from '../public/images/Viva.svg';
import PowerPlatform from '../public/images/PowerPlatform.svg';
import Dynamics365 from '../public/images/Dynamics365.svg';
import Microsoft365 from '../public/images/Microsoft365.svg';
import AzureFill from '../public/images/AzureFill.svg';
import EntraID from '../public/images/EntraID.svg';
import KubernetesServices from '../public/images/KubernetesServices.svg';
import ManagedService from '../public/images/ManagedService.svg';
import VirtualMachine from '../public/images/VirtualMachine.svg';
import AppServices from '../public/images/AppServices.svg';
import Networking from '../public/images/Networking.svg';
import NetworkingGrey from '../public/images/NetworkingGrey.svg';
import DeveloperTool from '../public/images/DeveloperTool.svg';
import DeveloperToolGrey from '../public/images/DeveloperToolGrey.svg';
import Blockchain from '../public/images/Blockchain.svg';
import BlockchainGrey from '../public/images/BlockchainGrey.svg';
import Devops from '../public/images/Devops.svg';
import DevopsGrey from '../public/images/DevopsGrey.svg';
import MicrosoftEntraId from '../public/images/MicrosoftEntraId.svg';
import MicrosoftEntraIdGrey from '../public/images/MicrosoftEntraIdGrey.svg';
import Compute from '../public/images/Compute.svg';
import ComputeGrey from '../public/images/ComputeGrey.svg';
import Migration from '../public/images/Migration.svg';
import MigrationGrey from '../public/images/MigrationGrey.svg';
import Security from '../public/images/Security.svg';
import SecurityGrey from '../public/images/SecurityGrey.svg';
import Containers from '../public/images/Containers.svg';
import ContainersGrey from '../public/images/ContainersGrey.svg';
import Identity from '../public/images/Identity.svg';
import IdentityGrey from '../public/images/IdentityGrey.svg';
import MixReality from '../public/images/MixReality.svg';
import MixRealityGrey from '../public/images/MixRealityGrey.svg';
import Storage from '../public/images/Storage.svg';
import StorageGrey from '../public/images/StorageGrey.svg';
import Integration from '../public/images/Integration.svg';
import IntegrationGrey from '../public/images/IntegrationGrey.svg';
import MonitoringAndDiagnostics from '../public/images/MonitoringAndDiagnostics.svg';
import MonitoringAndDiagnosticsGrey from '../public/images/MonitoringAndDiagnosticsGrey.svg';
import SaaS from '../public/images/SaaS.svg';

// Each image is exported as as url
var imageMap = {
    BusinessCentral: BusinessCentral,
    CategoryAIMachineLearning: CategoryAIMachineLearning,
    CategoryAIMachineLearningGrey: CategoryAIMachineLearningGrey,
    MonitoringAndDiagnosticsGrey: MonitoringAndDiagnosticsGrey,
    IdentityGrey: IdentityGrey,
    ContainersGrey: ContainersGrey,
    MixRealityGrey: MixRealityGrey,
    BlockchainGrey: BlockchainGrey,
    StorageGrey: StorageGrey,
    IntegrationGrey: IntegrationGrey,
    MicrosoftEntraIdGrey: MicrosoftEntraIdGrey,
    SecurityGrey: SecurityGrey,
    MigrationGrey: MigrationGrey,
    DeveloperToolGrey: DeveloperToolGrey,
    ComputeGrey: ComputeGrey,
    Commerce: Commerce,
    CustomerService: CustomerService,
    CustomerVoice: CustomerVoice,
    NetworkingGrey: NetworkingGrey,
    DevopsGrey: DevopsGrey,
    MixedReality: MixedReality,
    Excel: Excel,
    FieldService: FieldService,
    FinanceOperations: FinanceOperations,
    Guides: Guides,
    HumanResorces: HumanResorces,
    Marketing: Marketing,
    Office: Office,
    OneNote: OneNote,
    Outlook: Outlook,
    PowerApps: PowerApps,
    PowerAutomate: PowerAutomate,
    PowerBI: PowerBI,
    PowerPoint: PowerPoint,
    PowerVirtualAgents: PowerVirtualAgents,
    Project: Project,
    ProjectOperations: ProjectOperations,
    ProjectServiceAutomation: ProjectServiceAutomation,
    RemoteAssist: RemoteAssist,
    Sales: Sales,
    ServicesDynamics365: ServicesDynamics365,
    ServicesMicrosoft365: ServicesMicrosoft365,
    ServicesPowerPlatform: ServicesPowerPlatform,
    SharePoint: SharePoint,
    SupplyChainManagement: SupplyChainManagement,
    Teams: Teams,
    Word: Word,
    MSlogo: MSlogo,
    MSlogoSmall: MSlogoSmall,
    Separator: Separator,
    Partners: Partners,
    Azure: Azure,
    ChevronRight: ChevronRight,
    PowerPages: PowerPages,
    Viva: Viva,
    PowerPlatform: PowerPlatform,
    Dynamics365: Dynamics365,
    Microsoft365: Microsoft365,
    AzureFill: AzureFill,
    EntraID: EntraID,
    KubernetesServices: KubernetesServices,
    ManagedService: ManagedService,
    VirtualMachine: VirtualMachine,
    AppServices: AppServices,
    Networking: Networking,
    DeveloperTool: DeveloperTool,
    Blockchain: Blockchain,
    Devops: Devops,
    MicrosoftEntraId: MicrosoftEntraId,
    Compute: Compute,
    Migration: Migration,
    Security: Security,
    Containers: Containers,
    Identity: Identity,
    MixReality: MixReality,
    Storage: Storage,
    Integration: Integration,
    MonitoringAndDiagnostics: MonitoringAndDiagnostics,
    SaaS: SaaS,
    AIAgents: AIAgents,
    AIAgentsGrey: AIAgentsGrey
};

export { imageMap };
